var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheetPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.3317H10.8334V15.4984C10.8334 15.7194 10.7456 15.9313 10.5893 16.0876C10.433 16.2439 10.221 16.3317 10 16.3317C9.77901 16.3317 9.56705 16.2439 9.41077 16.0876C9.25449 15.9313 9.16669 15.7194 9.16669 15.4984V11.3317H5.00002C4.77901 11.3317 4.56705 11.2439 4.41076 11.0876C4.25448 10.9313 4.16669 10.7194 4.16669 10.4984C4.16669 10.2774 4.25448 10.0654 4.41076 9.90912C4.56705 9.75284 4.77901 9.66504 5.00002 9.66504H9.16669V5.49837C9.16669 5.27736 9.25449 5.0654 9.41077 4.90912C9.56705 4.75284 9.77901 4.66504 10 4.66504C10.221 4.66504 10.433 4.75284 10.5893 4.90912C10.7456 5.0654 10.8334 5.27736 10.8334 5.49837V9.66504H15C15.221 9.66504 15.433 9.75284 15.5893 9.90912C15.7456 10.0654 15.8334 10.2774 15.8334 10.4984C15.8334 10.7194 15.7456 10.9313 15.5893 11.0876C15.433 11.2439 15.221 11.3317 15 11.3317Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetPlus);
export default __webpack_public_path__ + "static/media/sheet-plus.b033a10bd9862f09c4b8620954d48383.svg";
export { ForwardRef as ReactComponent };